import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { axiosInstance } from '../../config';
import './SuperChats.css';

const SuperChats = () => {
  const { streamer = 'spirit' } = useParams();
  const [superChats, setSuperChats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSuperChats = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(`/superchat/${streamer}?limit=100`);
        setSuperChats(response.data);
      } catch (err) {
        setError('Failed to load SuperChats');
        console.error('Error fetching SuperChats:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSuperChats();
  }, [streamer]);

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleString();
  };

  if (loading) {
    return (
      <div className="superchats-page">
        <div className="superchats-header">
          <h1>SuperChats - {streamer}</h1>
        </div>
        <div className="loading">Loading SuperChats...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="superchats-page">
        <div className="superchats-header">
          <h1>SuperChats - {streamer}</h1>
        </div>
        <div className="error">{error}</div>
      </div>
    );
  }

  return (
    <div className="superchats-page">
      <div className="superchats-header">
        <h1>SuperChats - {streamer}</h1>
        <p>Recent SuperChat messages and tips</p>
      </div>

      <div className="superchats-container">
        {superChats.length === 0 ? (
          <div className="no-superchats">
            <p>No SuperChats yet for {streamer}</p>
            <p>Be the first to send a SuperChat!</p>
          </div>
        ) : (
          <div className="superchats-list">
            {superChats.map((superChat) => (
              <div key={superChat._id} className="superchat-item">
                <div className="superchat-header">
                  <div className="superchat-user">
                    <span className="user-name">{superChat.user}</span>
                    <span className="superchat-amount">{formatAmount(superChat.amount)}</span>
                  </div>
                  <div className="superchat-time">
                    {formatTime(superChat.timestamp)}
                  </div>
                </div>
                <div className="superchat-message">
                  {superChat.message}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SuperChats; 